import { updateQueryString } from './includes/shared/utils.js';
import { elements } from './includes/films/elements.js';
import { preloadFormFields } from './includes/films/preloadFormFields.js';
import { fetchResults } from './includes/films/fetchResults.js';
import { bindFormElements } from './includes/films/bindFormElements.js';
import { initializeExpandableFilter } from '../includes/collapseFilterGroup.js';

const isFilmsPage = () => {
    return !!elements.searchForm && !!elements.resultsContainer;
};

export const initializeSearchFilms = () => {
    if (!isFilmsPage()) return;

    const { allChoices } = preloadFormFields();
    bindFormElements(fetchResults, updateQueryString, allChoices);
    fetchResults();
    initializeExpandableFilter(elements.expandFilterButton, elements.expandableFilter);
};
